// extracted by mini-css-extract-plugin
export default {"NotificationDialog":"styles_NotificationDialog__-zBfm","Message":"styles_Message__gMfMI"};